import { AutogenModelTablePropertyList, AutogenRowTablePropertyList } from "./autogen/AutogenModelTablePropertyList";

export class ModelTablePropertyList extends AutogenModelTablePropertyList<RowTablePropertyList> {
	constructor() {
		super(RowTablePropertyList);
	}
}

export class RowTablePropertyList extends AutogenRowTablePropertyList {
}
